module.exports = __webpack_public_path__ + "static/media/IconDropdownMenu.04451d1b.svg";